import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataManualArticle } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_MANUAL_ARTICLE = defineMasterdataEntity<MasterdataManualArticle>({
  name: 'manual-article',
  responseKey: 'manualArticles',
  displayWith: (m) => {
    const name = [m.description1, m.description2].filter(Boolean).join(' ');
    return keyName(m.key, name || null);
  },
  secondaryWith: (m) => m.articleNumber,
  icon: 'fa-regular fa-box-open',
  title: 'Manuelle Artikelsuche',
  label: 'Manueller Artikel',
  placeholder: 'Manuellen Artikel suchen...',
  columns: [
    {
      label: 'Manueller Artikel',
      type: 'entity',
      icon: 'fa-regular fa-box-open',
      value: (e) =>
        keyName(
          e.key,
          [e.description1, e.description2].filter(Boolean).join(' ') || null,
        ),
      secondary: (e) => e.articleNumber,
    },
    { label: 'Schlüssel', value: (e) => e.key },
    { label: 'Artikelnummer', value: (e) => e.articleNumber },
    { label: 'Profimarkt-Nr.', value: (e) => e.profimarktNumber },
    { label: 'Hagebau-Nr.', value: (e) => e.hagebauNumber },
    { label: 'Bezeichnung', value: (e) => e.description1 },
    { label: 'Bezeichnung 2', value: (e) => e.description2 },
    { label: 'Bezeichnung 3', value: (e) => e.description3 },
    { label: 'Lieferantenartikelnummer', value: (e) => e.supplierArticleNumber },
    { label: 'Erfasst am', value: (e) => e.capturedAt },
  ],
});
